<template>
  <v-container fluid>
    <div class="d-flex align-center mb-2" style="gap: 8px;">
      <v-btn icon @click="$router.push('/business-relationships/companies')">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <h2 class="page-title">{{ companyName || 'Detalle de empresa' }}</h2>
    </div>

    <CompanyReportSection :companyId="companyId" :preselectContratoId="$route.query.contratoId" />
  </v-container>
</template>

<script>
import CompanyReportSection from '@/components/CompanyReportSection.vue';
import CompanieServices from '@/services/companie.service';

export default {
  name: 'CompanyDetails',
  components: { CompanyReportSection },
  props: {
    companyId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      companyName: '',
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    const res = await CompanieServices.getCompanyById(this.companyId);
    if (res.status === 'ok') {
      this.companyName = res.data.name || '';
    }
  },
};
</script>

<style scoped>
.page-title {
  color: #104b94;
  font-weight: 700;
}
</style>
